import {showSuccess, showError} from 'perform-base/js/flashes';

export default function () {
  $('#workLogForm').submit(function() {
    var form = $(this);
    $.ajax({
      url: form.attr('action'),
      type: 'POST',
      data: form.serialize(),
      success: function (data) {
        form.find('#details').val('');
        showSuccess(data.message);
        loadLogs();
      },
      error: function (data) {
        showError(data.responseJSON.message);
      }
    });

    return false;
  });

  var template = _.template($('#template-worklog').html());
  var listUrl = $('.project-worklogs').data('url-logs');

  var loadLogs = function() {
    $.ajax({
      url: listUrl,
      type: 'get',
      success: function (data) {
        $('.project-worklogs').html('');
        for (var i=0; i < data.workLogs.length; i++) {
          var log = data.workLogs[i];
          $('.project-worklogs').append(template({
            type: log.type,
            timeSummary: log.timeSummary,
            timezoneHourOffset: log.timezoneHourOffset,
            hours: log.hours,
            taskTitle: log.taskTitle,
            details: log.details,
            user: log.user,
          }));
        }
      }
    });
  };

  loadLogs();

  $('#projectSelect').change(function() {
    window.location = $(this).val();
  });
};



// WEBPACK FOOTER //
// ./assets/js/add-worklog.js